// extracted by mini-css-extract-plugin
export default {"host":"styles_host__WXBzX","icon":"styles_icon__B3HoS","title":"styles_title__e3cRv","message":"styles_message__7iBtL"};